export default "__VITE_ASSET__B784TxH0__"